import { render, staticRenderFns } from "./TestPackSelector.vue?vue&type=template&id=0fb20721&"
import script from "./TestPackSelector.vue?vue&type=script&lang=js&"
export * from "./TestPackSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports